module.exports = __webpack_public_path__ + "img/apple-ipad-9.406d17da.png";